import { render, staticRenderFns } from "./AppScoresNBA.vue?vue&type=template&id=99370728&"
import script from "./AppScoresNBA.vue?vue&type=script&lang=js&"
export * from "./AppScoresNBA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports